import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import initialWorkingHoursState from './working-hours-initial-state';
import { WorkingHoursType } from '../../../shared/enums/workingHoursType.enum';

const workingHoursSlice = createSlice({
    name: 'workingHoursSlice',
    initialState: initialWorkingHoursState,
    reducers: {
        setCompany(state, { payload }: PayloadAction<string | undefined>) {
            state.company = payload;
        },
        setDepartment(state, { payload }: PayloadAction<string | undefined>) {
            state.department = payload;
        },
        setForklift(state, { payload }: PayloadAction<string | undefined>) {
            state.forklit = payload;
        },
        setShowFilters(state, { payload }: PayloadAction<boolean>) {
            state.showFilters = payload;
        },
        setViewType(state, { payload }: PayloadAction<'Table' | 'New' | 'Update'>) {
            state.viewType = payload;
        },
        setTableType(state, { payload }: PayloadAction<WorkingHoursType>) {
            state.tableType = payload;
        },
    }
});

export const {
    setCompany,
    setDepartment,
    setForklift,
    setShowFilters,
    setViewType,
    setTableType
} = workingHoursSlice.actions

export default workingHoursSlice.reducer